import React from 'react';

interface IThemes {
  [light: string]: string;
  dark: string;
}

export const themes: IThemes = {
  light: 'light',
  dark: 'dark',
};

export const ThemeContext = React.createContext(themes.light);
